import React from "react";
import { Button } from "../../../general/Button/Button";

export const RevokeButton: React.FC<{ onClick: () => void; isVisible: boolean }> = ({
  onClick,
  isVisible,
}) => {
  if (!isVisible) {
    return null;
  }
  return <Button onClick={onClick} text={"Revoke"} buttonType={"primary"} textSize={"Medium"} />;
};
